<template>
  <div class="overflow-auto table-container">
    <table
      class="w-max table table-striped table-hover table-main table-custom "
    >
      <thead class="position-sticky">
        <tr>
          <th
            v-for="(col, index) in fields"
            :key="index"
            class="text-center w-150px py-2 "
          >
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody v-if="items.length">
        <tr v-for="(item, rowIndex) in items" :key="rowIndex">
          <td
            v-for="(field, colIndex) in fields"
            :key="colIndex"
            class="text-center text-black my-2 w-150px"
          >
            <span v-if="field.key === 'created_time'">
              {{ $moment(item[field.key]).format("DD/MM/YYYY") }}
            </span>
            <span v-else-if="item[field.key] && item[field.key].type == 5">
              {{ $moment(item[field.key]).format("DD/MM/YYYY HH:MM") }}
            </span>
            <span v-else-if="item[field.key] && item[field.key].type == 7">
              {{ $moment(item[field.key]).format("DD/MM/YYYY") }}
            </span>
            <span v-else-if="item[field.key] && item[field.key].type == 8">
              <img
                :src="item[field.key].value"
                class="img-size"
                v-if="item[field.key].value !== '-'"
              />
              <img
                v-else
                src="@/assets/images/noimg.png"
                alt="no-image-product"
                class="img-size"
              />
            </span>
            <span v-else-if="typeof item[field.key] == 'object'">
              {{ item[field.key] ? item[field.key].value : "-" }}
            </span>
            <span v-else>
              {{ item[field.key] ? item[field.key] : "-" }}
            </span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="fields.length" class="text-center text-muted py-4">
            No matching records found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    fields: {
      type: Array,
      default: [],
    },
    items: {
      type: Array,
      default: [],
    },
  },
  components: {},
  name: "Inventory",
  data() {
    return {
      isBusy: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.img-size {
  width: 60px;
  height: 60px;
}

.w-150px {
  width: 150px;
}
.w-max {
  width: max-content;
  min-width: 100%;
}

.table-container {
  max-height: 400px;
  position: relative;
}

.position-sticky {
  position: sticky;
  top: 0;
}
</style>
